import React from 'react';

import SelectInput, { styles } from "../../../../Components/Inputs/SelectInput";
import CheckboxInput from "../../../../Components/Inputs/CheckboxInput";
import EntityConfigSection from "../../Components/EntityConfigSection";
import StackedFormRow from "../../../../Components/StackedForm/StackedFormRow";
import FormRow from "../../../../Components/HorizontalForm/FormRow";
import { combineErrors } from "../../../../Helpers/ErrorHelper";
import { MIN_FIXED_AMENITY_PAYMENT, MIN_VARIABLE_AMENITY_PAYMENT } from "./EntityPaymentConfig";
import { formatDuration } from "../../../../Helpers/DateTimeHelper";

const EntitySchedulingConfig = (props) => {
    const unitOptions = [
        {
            label: 'Day(s)',
            value: 'days',
        },
        {
            label: 'Week(s)',
            value: 'weeks',
        },
        {
            label: 'Month(s)',
            value: 'months',
        },
    ];

    const handleChange = (event) => {
        props.onChange(event.target.name, event.target.value);
    }

    const isVariable = () => {
        return (props.config.is_variable === 1);
    }

    return (
        <EntityConfigSection title="Scheduling Limits" isExpanded={props.isExpanded}>
            <div className="grid-x grid-margin-x">

                <div className="cell small-3">
                    <StackedFormRow
                        label={`Maximum active ${isVariable() ? 'timeslots' : 'bookings'}`}
                        errorMessage={props.errors.max_active_bookings}
                        labelClassName="margin-bottom-0"
                    >
                        <input
                            type="number"
                            name="max_active_bookings"
                            min="0"
                            value={props.config.max_active_bookings}
                            onChange={handleChange}
                        />
                    </StackedFormRow>
                </div>

                <div className="cell small-9"></div>

                <div className="cell small-3">
                    <StackedFormRow
                        label={`Max ${isVariable() ? 'timeslots ' : ''}per day`}
                        errorMessage={props.errors.max_per_day}
                        labelClassName="margin-bottom-0"
                    >
                        <input
                            type="number"
                            name="max_per_day"
                            min="0"
                            value={props.config.max_per_day}
                            onChange={handleChange}
                        />
                    </StackedFormRow>
                </div>

                <div className="cell small-3">
                    <StackedFormRow
                        label={`Max ${isVariable() ? 'timeslots ' : ''}per week`}
                        errorMessage={props.errors.max_per_week}
                        labelClassName="margin-bottom-0"
                    >
                        <input
                            type="number"
                            name="max_per_week"
                            min="0"
                            value={props.config.max_per_week}
                            onChange={handleChange}
                        />
                    </StackedFormRow>
                </div>

                <div className="cell small-3">
                    <StackedFormRow
                        label={`Max ${isVariable() ? 'timeslots ' : ''}per month`}
                        errorMessage={props.errors.max_per_month}
                        labelClassName="margin-bottom-0"
                    >
                        <input
                            type="number"
                            name="max_per_month"
                            min="0"
                            value={props.config.max_per_month}
                            onChange={handleChange}
                        />
                    </StackedFormRow>
                </div>

                <div className="cell small-3"></div>

                <div className="cell small-3">
                    <StackedFormRow
                        label="Min Advance Booking"
                        errorMessage={combineErrors([props.errors.min_advance_period, props.errors.min_advance_units])}
                        labelClassName="margin-bottom-0"
                    >
                        <input
                            type="number"
                            name="min_advance_period"
                            min="0"
                            value={props.config.min_advance_period}
                            onChange={e => props.onChange(e.target.name, e.target.value)}
                            className="time-period-input"
                        />

                        <SelectInput
                            name="min_advance_units"
                            options={unitOptions}
                            value={props.config.min_advance_units}
                            className="minimal display-inline-block"
                            classNamePrefix="react-select-minimal"
                            onChange={(e) => {
                                props.onChange(e.target.name, e.target.value);
                            }}
                            styles={styles}
                        />
                    </StackedFormRow>
                </div>

                <div className="cell small-3">
                    <StackedFormRow
                        label="Max Advance Booking"
                        errorMessage={combineErrors([props.errors.max_advance_period, props.errors.max_advance_units])}
                        labelClassName="margin-bottom-0"
                    >
                        <input
                            type="number"
                            name="max_advance_period"
                            min="0"
                            value={props.config.max_advance_period}
                            onChange={e => props.onChange(e.target.name, e.target.value)}
                            className="time-period-input"
                        />

                        <SelectInput
                            name="max_advance_units"
                            options={unitOptions}
                            value={props.config.max_advance_units}
                            className="minimal display-inline-block"
                            classNamePrefix="react-select-minimal"
                            onChange={(e) => props.onChange(e.target.name, e.target.value)}
                            styles={styles}
                        />
                    </StackedFormRow>
                </div>
            </div>

            <FormRow
                label="Recurring Bookings"
                errorMessage=""
                className="align-middle margin-top-1"
                leftCellClassName="cell small-12 medium-4"
                rightCellClassName="cell small-12 medium-3 text-right"
                disabled={!!props.config.payment_enabled}
                disabledTooltip="You cannot enable recurring bookings if payments are enabled"
            >
                <CheckboxInput
                    name="recurring_bookings"
                    checked={props.config.recurring_bookings}
                    onChange={e => props.onChange(e.target.name, e.target.checked)}
                    disabled={!!props.config.payment_enabled}
                />
            </FormRow>

        </EntityConfigSection>
    )
}

export default EntitySchedulingConfig;
